import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ListResource } from '../../../../components/ListResource/ListResource';

const DemirameData = ({ id, origin }) => {
  const { t } = useTranslation();

  const headers = [
    {
      label: 'sourcePost',
      key: 'sourcePost.name'
    },
    {
      label: 'colonne',
      key: 'colonne.title'
    },
    {
      label: 'title',
      key: 'title'
    },
    {
      label: 'arrival1Name',
      key: 'arrival1Name'
    },
    {
      label: 'arrival2Name',
      key: 'arrival2Name'
    },
    {
      label: 'voltage',
      key: 'voltage'
    },
    {
      label: 'rameTechnology',
      key: 'rameTechnology'
    },
    {
      label: 'cellsNumber',
      key: 'cellsNumber'
    },
    {
      label: 'createdBy',
      key: 'createdBy.first_name'
    },
    {
      label: 'createdBy',
      key: 'createdBy.last_name'
    }
  ];

  const columns = [
    {
      title: t('sourceposts.show.colonneData.sourcePost'),
      key: 'sourcePost',
      dataIndex: 'sourcePost',
      render: ({ name }) => name,
      sorter: true
    },
    {
      title: t('sourceposts.show.DemirameData.colonne'),
      key: 'colonne',
      dataIndex: 'colonne',
      render: ({ title }) => title,
      sorter: true
    },
    {
      title: t('sourceposts.show.DemirameData.name'),
      key: 'title',
      dataIndex: 'title',
      sorter: true
    },
    {
      title: t('sourceposts.show.DemirameData.arrival1Name'),
      key: 'arrival1Name',
      dataIndex: 'arrival1Name',
      sorter: true
    },
    {
      title: t('sourceposts.show.DemirameData.arrival2Name'),
      key: 'arrival2Name',
      dataIndex: 'arrival2Name',
      sorter: true
    },
    {
      title: t('sourceposts.show.DemirameData.voltage'),
      key: 'voltage',
      dataIndex: 'voltage',
      sorter: true
    },
    {
      title: t('sourceposts.show.DemirameData.rameTechnology'),
      key: 'rameTechnology',
      dataIndex: 'rameTechnology',
      sorter: true
    },
    {
      title: t('sourceposts.show.DemirameData.cellsNumber'),
      key: 'cellsNumber',
      dataIndex: 'cellsNumber',
      sorter: true
    },
    {
      title: t('sourceposts.show.DemirameData.createdBy'),
      key: 'createdBy',
      dataIndex: 'createdBy',
      render: ({ first_name, last_name }) => `${first_name} ${last_name}`,
      sorter: true
    }
  ];
  return (
    <ListResource
      withCreateButton={false}
      showAction={false}
      deleteAction={false}
      resourceName="demirames"
      columns={columns}
      headers={headers}
      populate="sourcePost,colonne,createdBy,updatedBy"
      extraQuery={`sourcePost=${id}&model=${origin}`}
      resourceModelName="Demirame"
      showTitle={false}
      path="/sourceposts/demirame"
      withImportButton={false}
    />
  );
};

export default DemirameData;

DemirameData.propTypes = {
  id: PropTypes.string.isRequired,
  origin: PropTypes.string.isRequired
};
